export const onSetGoalsTarget = (data, get) => {
  get().setGoalsTarget(data.goalsTarget);
};
